<template>
  <div class="intro h-screen">
    <IntroFirstPage v-if="currentPage == 0" />
    <IntroSecondPage v-if="currentPage == 1" />
    <IntroThirdPage v-if="currentPage == 2" />
  </div>
</template>

<script>
// @ is an alias to /src
import IntroFirstPage from "@/components/introduction/IntroFirstPage.vue";
import IntroSecondPage from "@/components/introduction/IntroSecondPage.vue";
import IntroThirdPage from "@/components/introduction/IntroThirdPage.vue";

export default {
  name: "Intro",
  components: {
    IntroFirstPage,
    IntroSecondPage,
    IntroThirdPage
  },
  data(){
    return{
    currentPage: 0,
    }
  },
  methods:{
    skipForward(){
      if (this.currentPage < 2) {
        this.currentPage += 1;
      } else {
        this.$router.push({name: 'Start'})
      }
    },
  },
  mounted(){
    Event.$on('skipIntroForward', () => {this.skipForward()});
  }
};
</script>
